// extracted by mini-css-extract-plugin
export var content = "signs-module--content--uuUR+";
export var footer = "signs-module--footer--InzTh";
export var icon = "signs-module--icon--dH2hg";
export var iconContainer = "signs-module--iconContainer--wyACg";
export var image = "signs-module--image--ZSQaF";
export var section = "signs-module--section--kX9rG";
export var show = "signs-module--show--MUzsO";
export var text = "signs-module--text--6SFAH";